import { combineReducers } from "redux";
import cartReducer from "./Features/Card/cartReducer";
import homeReducer from "./Features/ProductsPage/productsReducer";

const rootReducer = combineReducers({
 allProducts: homeReducer,
 cart: cartReducer,
});
export default rootReducer;
